// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import CheckallController from "./checkall_controller";
application.register("checkall", CheckallController);

import CheckboxLikeRadioController from "./checkbox_like_radio_controller";
application.register("checkbox-like-radio", CheckboxLikeRadioController);

import CodeEditorController from "./code_editor_controller";
application.register("code-editor", CodeEditorController);

import ColorPickerController from "./color_picker_controller";
application.register("color-picker", ColorPickerController);

import DateRangeController from "./date_range_controller";
application.register("date-range", DateRangeController);

import HeaderSearchController from "./header_search_controller";
application.register("header-search", HeaderSearchController);

import InputMaskController from "./input_mask_controller";
application.register("input-mask", InputMaskController);

import InternationalPhoneInputController from "@/javascript/controllers/international_phone_input_controller.js";
application.register("international-phone-input", InternationalPhoneInputController);

import JolifishSwiperController from "./jolifish_swiper_controller";
application.register("jolifish-swiper", JolifishSwiperController);

import KeyboardController from "./keyboard_controller";
application.register("keyboard", KeyboardController);

import MasonryController from "./masonry_controller";
application.register("masonry", MasonryController);

import MeasurementController from "./measurement_controller";
application.register("measurement", MeasurementController);

import PieController from "./pie_controller";
application.register("pie", PieController);

import PopperController from "./popper_controller";
application.register("popper", PopperController);

import PreserveScrollController from "./preserve_scroll_controller";
application.register("preserve-scroll", PreserveScrollController);

import SortableController from "./sortable_controller";
application.register("sortable", SortableController);

import ToggleVisibilityController from "./toggle_visibility_controller";
application.register("toggle-visibility", ToggleVisibilityController);

import TomSelectController from "./tom_select_controller";
application.register("tom-select", TomSelectController);

import UpdateQuantityController from "./update_quantity_controller";
application.register("update-quantity", UpdateQuantityController);

import UploadController from "./upload_controller";
application.register("upload", UploadController);

import AdminBarController from "./admin_bar_controller";
application.register("admin-bar", AdminBarController);

import FormReloadController from "./form_reload_controller";
application.register("form-reload", FormReloadController);

import InstalikeController from "./instalike_controller";
application.register("instalike", InstalikeController);

import AddToCartController from "./add_to_cart_controller";
application.register("add-to-cart", AddToCartController);

import ProductVariantCardController from "./product_variant_card_controller";
application.register("product-variant-card", ProductVariantCardController);

import TurnstileController from "./turnstile_controller";
application.register("turnstile", TurnstileController);

import TextAnimationController from "./text_animation_controller";
application.register("text-animation", TextAnimationController);

import SendSubmissionController from "./send_submission_controller";
application.register("send-submission", SendSubmissionController);

import ToggleVisibilityOnValueController from "./toggle_visibility_on_value_controller";
application.register("toggle-visibility-on-value", ToggleVisibilityOnValueController);

import OrderAccordeonController from "./order_accordeon_controller";
application.register("order-accordeon", OrderAccordeonController);

import ContainedImageController from "./contained_image_controller";
application.register("contained-image", ContainedImageController);
